// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { PlanPackageSummary_PlanPackageFragmentDoc } from './components/PlanPackageSummary.generated';
import { NamedFragmentDoc, DisplayNamedFragmentDoc } from '../../../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PlanPackageOverviewQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.TakeoffLineItemFilter>;
  order?: Types.InputMaybe<Array<Types.TakeoffLineItemOrder> | Types.TakeoffLineItemOrder>;
  versionId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type PlanPackageOverviewQuery = { __typename?: 'Query', itemCount: { __typename?: 'TakeoffLineItemsPage', groupTotals: Array<{ __typename?: 'TakeoffLineItemGroupTotal', groupId: string, tlisInGroup: number }> } };

export type PlanSummaryAndOptionsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  versionId: Types.Scalars['ID']['input'];
}>;


export type PlanSummaryAndOptionsQuery = { __typename?: 'Query', planPackage: { __typename?: 'PlanPackage', id: string, displayName: string, designPackageCount: number, productOfferingCount: number, projectCount: number, options: Array<{ __typename?: 'ReadyPlanOption', code: string, order: number, active: boolean, id: string, name: string, programData: { __typename?: 'ProgramData', id: string, sellableSqft?: number | null | undefined }, type: { __typename?: 'GlobalOptionType', isElevation: boolean, id: string, name: string }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined }>, assets: Array<{ __typename?: 'ReadyPlanAsset', id: string, active: boolean, isCoverPhoto: boolean, asset: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } }>, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string }, minProgramData: { __typename?: 'ProgramData', id: string, sellableSqft?: number | null | undefined, stories?: number | null | undefined, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined }, maxProgramData: { __typename?: 'ProgramData', id: string, sellableSqft?: number | null | undefined, stories?: number | null | undefined, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined } } };

export type PlanPackageOverview_GroupTotalsFragment = { __typename?: 'TakeoffLineItemGroupTotal', groupId: string, tlisInGroup: number };

export type PlanPackageOverview_ReadyPlanOptionFragment = { __typename?: 'ReadyPlanOption', code: string, order: number, active: boolean, id: string, name: string, programData: { __typename?: 'ProgramData', id: string, sellableSqft?: number | null | undefined }, type: { __typename?: 'GlobalOptionType', isElevation: boolean, id: string, name: string }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined };

export const PlanPackageOverview_GroupTotalsFragmentDoc = gql`
    fragment PlanPackageOverview_GroupTotals on TakeoffLineItemGroupTotal {
  groupId
  tlisInGroup
}
    `;
export const PlanPackageOverview_ReadyPlanOptionFragmentDoc = gql`
    fragment PlanPackageOverview_ReadyPlanOption on ReadyPlanOption {
  ...Named
  code
  order
  programData {
    id
    sellableSqft
  }
  active
  type {
    ...Named
    isElevation
  }
  location {
    ...Named
  }
}
    ${NamedFragmentDoc}`;
export const PlanPackageOverviewDocument = gql`
    query PlanPackageOverview($filter: TakeoffLineItemFilter, $order: [TakeoffLineItemOrder!], $versionId: ID) {
  itemCount: takeoffLineItemsPage(
    filter: $filter
    order: $order
    versionId: $versionId
  ) {
    groupTotals {
      ...PlanPackageOverview_GroupTotals
    }
  }
}
    ${PlanPackageOverview_GroupTotalsFragmentDoc}`;

/**
 * __usePlanPackageOverviewQuery__
 *
 * To run a query within a React component, call `usePlanPackageOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanPackageOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanPackageOverviewQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function usePlanPackageOverviewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PlanPackageOverviewQuery, PlanPackageOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanPackageOverviewQuery, PlanPackageOverviewQueryVariables>(PlanPackageOverviewDocument, options);
      }
export function usePlanPackageOverviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanPackageOverviewQuery, PlanPackageOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanPackageOverviewQuery, PlanPackageOverviewQueryVariables>(PlanPackageOverviewDocument, options);
        }
export function usePlanPackageOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageOverviewQuery, PlanPackageOverviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanPackageOverviewQuery, PlanPackageOverviewQueryVariables>(PlanPackageOverviewDocument, options);
        }
export type PlanPackageOverviewQueryHookResult = ReturnType<typeof usePlanPackageOverviewQuery>;
export type PlanPackageOverviewLazyQueryHookResult = ReturnType<typeof usePlanPackageOverviewLazyQuery>;
export type PlanPackageOverviewSuspenseQueryHookResult = ReturnType<typeof usePlanPackageOverviewSuspenseQuery>;
export type PlanPackageOverviewQueryResult = Apollo.QueryResult<PlanPackageOverviewQuery, PlanPackageOverviewQueryVariables>;
export const PlanSummaryAndOptionsDocument = gql`
    query PlanSummaryAndOptions($id: ID!, $versionId: ID!) {
  planPackage(id: $id, versionId: $versionId) {
    ...PlanPackageSummary_PlanPackage
    options {
      ...PlanPackageOverview_ReadyPlanOption
    }
  }
}
    ${PlanPackageSummary_PlanPackageFragmentDoc}
${PlanPackageOverview_ReadyPlanOptionFragmentDoc}`;

/**
 * __usePlanSummaryAndOptionsQuery__
 *
 * To run a query within a React component, call `usePlanSummaryAndOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanSummaryAndOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanSummaryAndOptionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function usePlanSummaryAndOptionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PlanSummaryAndOptionsQuery, PlanSummaryAndOptionsQueryVariables> & ({ variables: PlanSummaryAndOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanSummaryAndOptionsQuery, PlanSummaryAndOptionsQueryVariables>(PlanSummaryAndOptionsDocument, options);
      }
export function usePlanSummaryAndOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanSummaryAndOptionsQuery, PlanSummaryAndOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanSummaryAndOptionsQuery, PlanSummaryAndOptionsQueryVariables>(PlanSummaryAndOptionsDocument, options);
        }
export function usePlanSummaryAndOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanSummaryAndOptionsQuery, PlanSummaryAndOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanSummaryAndOptionsQuery, PlanSummaryAndOptionsQueryVariables>(PlanSummaryAndOptionsDocument, options);
        }
export type PlanSummaryAndOptionsQueryHookResult = ReturnType<typeof usePlanSummaryAndOptionsQuery>;
export type PlanSummaryAndOptionsLazyQueryHookResult = ReturnType<typeof usePlanSummaryAndOptionsLazyQuery>;
export type PlanSummaryAndOptionsSuspenseQueryHookResult = ReturnType<typeof usePlanSummaryAndOptionsSuspenseQuery>;
export type PlanSummaryAndOptionsQueryResult = Apollo.QueryResult<PlanSummaryAndOptionsQuery, PlanSummaryAndOptionsQueryVariables>;